
import React from 'react';
import { Star, PawPrint, Cat } from 'lucide-react';

const FeaturedTestimonial: React.FC = () => {
  return (
    <section className="py-12 bg-[#FDF6ED]" aria-labelledby="testimonial-highlight">
      <div className="container mx-auto px-4 max-w-4xl">
        <div className="bg-white p-8 rounded-lg shadow-elegant relative">
          <div className="flex flex-col items-center text-center">
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-[#C46829] rounded-full p-3">
              <Cat size={24} className="text-white" aria-hidden="true" />
            </div>
            <div className="mb-4 mt-4">
              {[1, 2, 3, 4, 5].map(star => (
                <Star key={star} size={20} className="inline-block mx-0.5 text-[#D4AF37]" aria-hidden="true" />
              ))}
            </div>
            <blockquote className="text-lg md:text-xl italic mb-6 text-[#8B4513]">
              "I never knew cats played such a big role in NYC history! Peggy's passion was infectious, and I learned so many fascinating stories. This was the highlight of my trip to New York."
            </blockquote>
            <div className="flex items-center justify-center gap-2">
              <PawPrint size={16} className="text-[#C46829]" aria-hidden="true" />
              <cite className="text-[#8B4513] font-semibold not-italic">— Sarah, Chicago</cite>
              <PawPrint size={16} className="text-[#C46829]" aria-hidden="true" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedTestimonial;
